// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> glen-arbors-apartments
// Generated: 2026-09-23T21:47:48.819Z
// Counts: 1 design, 13 content, 2 slot group, 2 collection binding, 7 section, 1 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore affordable two- and three-bedroom apartment floor plans at Glen Arbors in Napoleon, OH. Our LIHTC community offers project-based Section 8 apartment homes for qualifying households.</p><p>Depending on the apartment home, income limits range from 40% to 60% of the Area Median Income (AMI). Housing Choice Vouchers are accepted. Browse available floor plans and contact us to learn about current qualification requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable 2 &amp; 3 Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Dogs and cats allowed (spayed/neutered), up to 30 lb each. Pet deposit: $200 per animal. Monthly pet rent: $25 per animal. Maximum 2 pets per unit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.pet_deposit_value": {
    "overrideType": "VALUE",
    "customValue": "200",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Glen Arbors, offering affordable apartments in Napoleon, OH with spacious two- and three-bedroom floor plans. Enjoy a peaceful setting with abundant green space, fully equipped kitchens, private balconies or patios, ample parking, and professional on-site management.</p><p>Glen Arbors participates in the Low-Income Housing Tax Credit (LIHTC) program and offers project-based Section 8 apartment homes. Income limits range from 40% to 60% of the Area Median Income (AMI), depending on the apartment home. Housing Choice Vouchers are accepted.</p><p>Explore our affordable apartments in Napoleon, OH, and contact our leasing team to learn more about current availability and income qualifications.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_bc205b20-b0d0-4260-9fd6-b5c1285802af",
      "custom_4fce2a08-1546-457e-be2b-dbb68edef2ce",
      "custom_e0bfab17-f68b-45b2-a70f-4eb2188a4602",
      "custom_7e19ff3f-a94c-4488-aa03-f764ae03ccdf",
      "custom_759c8997-7662-4158-b4b8-e2b3f7a8a9a9",
      "custom_e2364b52-1893-43ca-9788-1890e85f8898",
      "custom_ecad7bad-3b2d-42b6-b1e3-537cf7f32b8e",
      "custom_b51bdeb8-68b0-4fef-a169-402e843a73d1",
      "custom_962d7225-c323-4a39-812e-e69e6f9bceb3",
      "custom_ce39ff19-494f-42f0-ac46-447291e77cdf",
      "custom_417df0ae-1b85-461c-bd01-64e9a3e8a6b2"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      8,
      10,
      5,
      9,
      11,
      12,
      18,
      16,
      13,
      15,
      17
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_564f4321-3eaa-4307-8367-69e217626594",
      "custom_cc09b47e-e547-48e5-81c0-ce1dfb2c7f66",
      "custom_1ee0221d-fba1-43b0-9524-41be6d1ff161",
      "custom_acd66fda-b6ed-437a-99ba-5d206cec7076",
      "custom_d9be7908-3f69-4081-9100-a7e138fd305d",
      "custom_0262bb1a-5098-4ce9-8942-b796d1a75704",
      "custom_4074bc9d-4db9-4537-98fb-0574e580ad77"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      4,
      2,
      5,
      8,
      16,
      15,
      18
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.InstagramSection": {
    "properties": {
      "display": "none"
    }
  }
};
